// Presentatiehulp voor de admin-tab "App-versies". Los van de component zodat
// de sortering testbaar is zonder React — zelfde opzet als
// translateArchiveDisplay.ts hiernaast.

function parts(version: string): [number, number, number] {
  const head = version.split("-")[0].split("+")[0];
  const chunks = head.split(".");
  const read = (index: number): number => {
    const value = Number.parseInt(chunks[index] ?? "", 10);
    return Number.isNaN(value) ? 0 : value;
  };
  return [read(0), read(1), read(2)];
}

/** Negatief als `a` ouder is dan `b`, 0 bij gelijk, positief als `a` nieuwer is. */
export function compareVersions(a: string, b: string): number {
  const left = parts(a);
  const right = parts(b);
  for (let i = 0; i < 3; i += 1) {
    if (left[i] !== right[i]) return left[i] - right[i];
  }
  return 0;
}

/** Nieuwste versie eerst. Geeft een nieuwe array terug. */
export function sortVersionsDesc<T extends { version: string }>(items: T[]): T[] {
  return [...items].sort((a, b) => compareVersions(b.version, a.version));
}

/** "3 gebruikers · 75,5%" — Nederlandse decimaalkomma, geen nullen erachter. */
export function formatShare(users: number, percentage: number): string {
  const noun = users === 1 ? "gebruiker" : "gebruikers";
  const pct = percentage.toFixed(1).replace(/\.0$/, "").replace(".", ",");
  return `${users} ${noun} · ${pct}%`;
}
